import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoCondensedDisplay, {
    AddressInfoCondensedDisplayStyles,
} from "@insite/content-library/Components/AddressInfoCondensedDisplay";
import { DistanceUnitOfMeasure } from "@insite/content-library/Components/DistanceDisplay";
// import LocationPagination from "@insite/content-library/Components/LocationPagination";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Radio, { RadioComponentProps, RadioStyle } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
import parse from "html-react-parser";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { StyledButton } from "@insite/mobius/Clickable";
import getColor from "@insite/mobius/utilities/getColor";
import ADIGoogleMapsDirectionLink from "@NA/Components/ADIGoogleMapsDirectionLink";
import ADIDistanceDisplay from "@NA/Components/ADIDistanceDisplay";
import ADIColors from "@NA/Utils/ADIColors";
import ChevronDown from "@insite/mobius/Icons/ChevronDown";

import ChevronUp from "@insite/mobius/Icons/ChevronUp";

import { StyledIcon } from "@insite/mobius/Link";
import { useState } from "react";
import LocationPagination from "./LocationPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";

interface CustomLocationModel {
    id: string;
    latitude: number;
    longitude: number;
    distance: number;
    hours?: string;
    name: string;
    address1: string;
    address2?: string;
    city: string;
    state: string;
    postalCode: string;
    phone?: string;
    htmlContent?: string;
    properties?: any;
}

interface OwnProps {
    extendedStyles?: LocationSearchFormStyles;
    onSearch: (searchGeoLocationFilter: string, searchLocationFilter: string, radiusSearch?: number) => void;

    onLocationSelected: (location: LocationModel, locationNumber: number) => any;
    locationKnown: boolean;
    showSelectedLocation: boolean;
    getLocationNumberFromPagination: (locationIndex: number) => number;
    openLocationContentDisplay: (location: LocationModel) => void;
    resultCount: number;
    locationSearchFilter: string;
    radiusSearchFilter?: number;
    geoLocationSearchText: string;
    showGeoLocationErrorMessage: boolean;
    geoLocationErrorMessage: React.ReactNode;
    isLoading: boolean;
    distanceUnitOfMeasure: DistanceUnitOfMeasure;
    setDistanceUnitOfMeasure: (uom: DistanceUnitOfMeasure) => void;
    locations: LocationModel[];
    locationsPagination: PaginationModel | undefined;
    setPage: (page: number) => void;
    setPageSize: (pageSize: number) => void;
    siteMessageResultsErrorMessage: React.ReactNode;
    onHover?: any;
    hoveredIndex?: any;
    customlocations?: CustomLocationModel[];
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    settings: getSettingsCollection(state),
});

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface LocationSearchFormStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    form?: InjectableCss;
    searchContainer?: InjectableCss;
    searchInputRow?: InjectableCss;
    searchInputGridContainer: GridContainerProps;
    searchResultsTextGridItem?: GridItemProps;
    searchResultsText?: TypographyPresentationProps;
    distanceUnitOfMeasureGridItem?: GridItemProps;
    distanceUnitOfMeasureRadioGroup?: RadioGroupProps;
    distanceUnitOfMeasureImperialRadio?: RadioComponentProps;
    distanceUnitOfMeasureMetricRadio?: RadioComponentProps;
    searchResultGridItem?: GridItemProps;
    searchResultRow?: InjectableCss;
    searchResultGridContainer?: GridContainerProps;
    searchResultLocationDetailsGridContainer?: GridContainerProps;
    searchResultDisplayNumberGridItem?: GridItemProps;
    locationDisplayNumberText?: TypographyPresentationProps;
    searchResultLocationGridItem?: GridItemProps;
    rightSectionTextGridItem?: GridItemProps;
    rightSectionGridContainer?: GridContainerProps;
    locationNameText?: TypographyPresentationProps;
    locationNameLink?: LinkPresentationProps;
    searchResultAddressInfoGridItem?: GridItemProps;
    locationAddressInfoCondensed?: AddressInfoCondensedDisplayStyles;
    searchResultLinksAndDistanceContainer?: GridContainerProps;
    searchResultPhoneGridItem?: GridItemProps;
    searchResultPhoneLink?: LinkPresentationProps;
    searchResultContentGridItem?: GridItemProps;
    locationContentLink?: LinkPresentationProps;
    searchResultGoogleMapsDirectionLinkGridItem?: GridItemProps;
    searchResultManagerGridItem?: GridItemProps;
    locationGoogleMapsDirectionLink?: LinkPresentationProps;
    searchResultDistanceGridItem?: GridItemProps;
    locationDistanceDisplayText?: TypographyPresentationProps;
    searchResultDividerGridItem?: GridItemProps;
    searchResultDivider?: InjectableCss;
    paginationRow?: GridItemProps;
    pagination?: PaginationPresentationProps;
    managesecstyle?: InjectableCss;
    showdetailsparagraph?: InjectableCss;
    iconHover?: InjectableCss;
}

export const locationSearchFormStyles: LocationSearchFormStyles = {

    locationDistanceDisplayText: {
        css: css`
            margin-left: auto;
            font-size: 14px;
            font-weight: bold;
            position: relative;
        `,
    },
    searchInputRow: {
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
          
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    form: {
        css: css`
            width: 100%;
        `,
    },
    searchContainer: {
        css: css`
            height: 642px;
            min-height: 800px;
            width: 100%;
          
            ${StyledButton} {
                &:focus {
                    outline: none;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                     padding: 10px 20px 0px 20px !important;
                    `,
                    css`
                    `,
                    css`
                    `,
                    null,
                    null,
                ])}
        `,
    },
    searchInputGridContainer: {
        gap: 10,
        css: css`
        width: 100%;
        @media only screen and (min-width: 1080px) {
   margin-bottom: 6px !important;
  
        }
         @media screen and (min-width: 768px) and (max-width: 1024px) {
                margin-bottom: 4px !important;
               
            }
            @media screen and (max-width: 767px) {
                margin-bottom: 4px !important;
               
            }
        `,
    },
    searchResultsText: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            color: ${ADIColors.darkBlack3};
            display: inline-block;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
        `,
    },
    searchResultsTextGridItem: {
        width: 6,
        align: "middle",
        css: css`
            padding-bottom: 0px;
           
        `,
    },
    distanceUnitOfMeasureGridItem: {
        width: 6,
        align: "middle",
        css: css`
            padding-bottom: 0px;
          
          @media only screen and (min-width: 1080px) {
  height:22px;
  min-height:22px;
}
        `,
    },
    distanceUnitOfMeasureRadioGroup: {
        css: css`
            display: inline-block;
            width: 100%;
            flex-direction: row;
            text-align: right;
            & > div {
                display: inline-flex;
            }
            > ${RadioStyle} {
                margin-top: 0px !important;
                > label {
                    margin-left: 0px;
                    font-size: 14px;
                    color: ${ADIColors.darkBlue1};
                    font-weight: bold;
                    margin-right: 10px;
                    &:before {
                        margin-right: 4px;
                        border: 1px solid #bbbbbb;
                    }
                }
                &:hover {
                    input + label::before {
                        margin-right: 4px;
                    }
                }
            }
        `,
    },
    searchResultGridItem: {
        width: 12,
        css: css`
           padding-bottom:0px !important;
            padding-top:0px !important;
            padding:0px !important;
        `,
    },
    searchResultRow: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 626px;
            height: 626px;
            padding-right: 0 !important;
            width: 100% !important;
            padding-top: 0 !important;
          
            &::-webkit-scrollbar {
                width: 5px;
                overflow-y: auto;
            }
            &::-webkit-scrollbar-track {
                background: ${getColor("text.disabled")};
                overflow-y: auto;
            }
            &::-webkit-scrollbar-thumb {
                border: solid 1px ${ADIColors.black} !important;
                background-color: ${ADIColors.gray4} !important;
                border-radius: 9px;
                overflow-y: auto;
            }
            @-moz-document url-prefix() {
                scrollbar-width: thin;
                //scrollbar-color: ${ADIColors.gray2} ${ADIColors.white};
            }
        `,
    },
    searchResultGridContainer: {
        gap: 10,
        css: css`
      
    `,
    },
    searchResultLocationDetailsGridContainer: {
        gap: 10,
    },
    searchResultDisplayNumberGridItem: {
        width: 1,
        css: css`
            justify-content: flex-start;
            
            padding-top: 15px;
             @media screen and (min-width: 768px) and (max-width: 1080px) {
                flex-basis: auto;
                max-width: 100%;
                padding-right:0px;
            }
            > ${TypographyStyle} {
                width: 27px;
                height: 25px;
                background-color: ${ADIColors.lightblue3};
                text-align: center;
                font-size: 14px;
                font-weight: bold;
                padding: 4px 10px 3px;
                margin-left: 4px;
                color: ${getColor("common.background")};
                display: flex;
                justify-content: center;
                align-items: center;
                word-break: keep-all;

            }
        `,
    },
    locationDisplayNumberText: {
        color: "primary",
        weight: "bold",
        css: css`
        margin-top: 10px;
        `
    },
    searchResultLocationGridItem: {
        width: 11,
        css: css`
            padding-bottom: 0px;
            flex-basis: 99%;
            max-width: 99%;
            padding-top:20px !important;

             ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`padding-right: 10px; padding-top: 10px;`,
                        css`padding-right: 10px; padding-top: 10px;`,
                        css`padding-right: 10px; padding-top: 10px;`,
                        css`padding-right: 15px;`,
                        css`padding-right: 15px;`,
                    ],
                    "min",
                )}
        `,
    },
    rightSectionTextGridItem: {
        width: 11,
        css: css`
          @media screen and (min-width: 768px) and (max-width: 1080px) {
                
                max-width: 95%;
               flex-basis:95%;
             
            }
            padding-left: 2px;
            padding-right: 0px;
        `,
    },
    rightSectionGridContainer: {
        css: css`
            > ${GridOffset} {
                width: 100%;
                margin: 0px;
            }
        `,
    },
    locationNameText: {
        color: "primary",
        weight: "bold",
        ellipsis: true,
    },
    locationNameLink: {
        color: "text.main",
        css: css`
            font-size: 18px !important;
            text-transform: capitalize;
            @media screen and (min-width: 768px) and (max-width: 1024px) {
                font-size: 16px !important;
                
            }
            @media screen and (max-width: 767px) {
                font-size: 16px !important;
              
            }
            ${TypographyStyle}{
                white-space: normal;
            } 
            + ${TypographyStyle}{
                white-space: nowrap;
            }
        `,
        typographyProps: {
            weight: "bold",
            ellipsis: true,
        },
    },
    searchResultAddressInfoGridItem: {
        width: 11,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
            > address {
                > ${TypographyStyle} {
                    font-size: 14px;
                }
            }
        `,
    },
    searchResultPhoneGridItem: {
        width: [11, 11, 11, 11, 11],
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
            ${TypographyStyle} {
                font-size: 14px;
            }
            > ${StyledButton} {
                > ${TypographyStyle} {
                    color: ${getColor("text.main")};
                    &:hover {
                        color: ${getColor("primary")};
                    }
                }
            }
        `,
    },
    searchResultLinksAndDistanceContainer: {
        gap: 0,
        css: css`
            width: 100%;
            padding: 0;
            margin: 0;
        `,
    },
    searchResultContentGridItem: {
        width: 11,
        css: css`
            flex-direction: column;
            padding-bottom: 0px;
            padding-top: 4px;
            ${TypographyStyle} {
                font-size: 14px;
            }
            .hoursText {
                font-weight: bold;
            }
        `,
    },
    searchResultGoogleMapsDirectionLinkGridItem: {
        width: 11,
        css: css`
            justify-content: space-between;
            padding-right: 8px;
            maxwidth: 98% !important;
            flex-basis: 98% !important;
            padding-bottom: 4px;
            padding-top: 4px;
             @media screen and (min-width: 768px) and (max-width: 1080px) {
             max-width:100%;
            }
            @media only screen and (max-width: 576px) {
              padding-right: 2px;
            }
            > ${TypographyStyle} {
                font-size: 14px;
                font-weight: bold;
            }
            > ${StyledButton} {
                > ${TypographyStyle} {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    img {
                        margin-left: 7px;
                        width: 7px;
                        height: 11px;
                    }
                }
            }
        `,
    },
    searchResultManagerGridItem: {
        width: 11,
        css: css`
            flex-direction: column;
            padding-bottom: 4px;
            padding-top: 4px;
            ${TypographyStyle} {
                font-size: 14px;
            }
            p {
                font-weight: bold;
            }
        `,
    },
    searchResultDistanceGridItem: {
        width: 4,
    },
    searchResultDividerGridItem: {
        width: 12,
        css: css`
          padding-top:0px !important;
           padding-bottom:0px !important;
        `,
    },
    searchResultDivider: {
        css: css`
           // margin: 5px 0 0px;
           margin:0px;
            border-bottom: 1px solid ${getColor("common.border")};
            width: 100%;
        `,
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                justify-content: center;
            `,
            perPageSelect: css`
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                display: none;
                            `,
                            null,
                            null,
                            null,
                            null,
                        ],
                        "min",
                    )}
            `,
        },
    },
    managesecstyle: {
        css: css`
            display: block;
            max-width: 100%;
            flex-basis: 100%;
            padding: 0px;
            margin-bottom: 10px !important;
            .dealer-dir{
            margin-top:-15px;
           
            }
        `,
    },
    showdetailsparagraph: {
        css: css`
            position: relative;
            left: 23px;
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`left: 21px;`,
                        css`left: 23px;`,
                        css`
                            position: relative;
                            left: 28px;
                        `,
                        null,
                        null,
                    ],
                    "min",
                )}
        `,
    },
    iconHover: {
        css: css`
        cursor: pointer;
        font-weight: 600;
       

        >${StyledIcon} {
            margin-left: 8px;
            @media (min-width: 768px) and (max-width: 1024px) {
  margin-right:17px;
}
  @media (max-width: 767px) {
  margin-right:2px;
}
        }
        `
    },
    searchResultPhoneLink: {
        css: css`
            text-decoration: underline;
        `
    },
};

const Container = StyledWrapper;
const ContainerCell = StyledWrapper;

const LocationSearchForm: React.FC<Props> = ({
    extendedStyles,
    onLocationSelected,
    getLocationNumberFromPagination,
    resultCount,
    isLoading,
    distanceUnitOfMeasure,
    setDistanceUnitOfMeasure,
    locations,
    locationsPagination,
    setPage,
    setPageSize,
    onHover,
    hoveredIndex,
    customlocations,
}) => {
    const [styles] = React.useState(() => mergeToNew(locationSearchFormStyles, extendedStyles));
    const handleDistanceUnitOfMeasureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as DistanceUnitOfMeasure;
        setDistanceUnitOfMeasure(value);
    };

    const generateLocationSelectClickHandler = (location: LocationModel, index: any) => {
        try {
            const locationNumber = getLocationNumberFromPagination(index);

            if (locationNumber) {
                onLocationSelected(location, locationNumber);
            }
        } catch (error) { }
    };

    const isNotFinalResult = (resultIndex: number) => {
        if (!locationsPagination) {
            return false;
        }
        return locationsPagination.pageSize > resultIndex + 1;
    };
    const [collapsedUsers, setCollapsedusers] = useState(Array(locations.length).fill(true));
    const [uncollapsedUser, setUnCollapseduser] = useState(0);

    const showdetailssection = (index: any) => {
        setCollapsedusers(prevState => prevState.map((val, idx) => idx !== index));

        setUnCollapseduser(prevIndex => (prevIndex === index ? -1 : index));
    };

    return (
        <Container {...styles.searchContainer}>
            <ContainerCell {...styles.searchInputRow}>
                <GridContainer {...styles.searchInputGridContainer}>
                    <GridItem {...styles.searchResultsTextGridItem}>
                        <Typography {...styles.searchResultsText}>
                            {translate("{0} Results").replace("{0}", `${resultCount}`)}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.distanceUnitOfMeasureGridItem}>
                        <RadioGroup
                            {...styles.distanceUnitOfMeasureRadioGroup}
                            id="distanceUoM"
                            name="distanceUoM"
                            value={distanceUnitOfMeasure}
                            onChangeHandler={handleDistanceUnitOfMeasureChange}
                        >
                            <Radio {...styles.distanceUnitOfMeasureImperialRadio} value="Imperial">
                                {translate("mi")}
                            </Radio>
                            <Radio {...styles.distanceUnitOfMeasureMetricRadio} value="Metric">
                                {translate("km")}
                            </Radio>
                        </RadioGroup>
                    </GridItem>
                </GridContainer>
            </ContainerCell>

            <ContainerCell {...styles.searchResultRow}>
                <GridContainer {...styles.searchResultGridContainer}>
                    {isLoading && locations.length === 0 && (
                        <GridItem {...styles.searchResultGridItem}>
                            <StyledWrapper {...styles.centeringWrapper}>
                                <LoadingSpinner {...styles.spinner} />
                            </StyledWrapper>
                        </GridItem>
                    )}
                    {customlocations?.map((location, index) => (
                        <GridItem key={location.id} {...styles.searchResultGridItem}>
                            <GridContainer
                                {...styles.searchResultGridContainer}
                                data-test-selector="locationSearchForm_location"
                                data-test-key={`${location.id}`}
                            >
                                <GridItem {...styles.searchResultDisplayNumberGridItem}>
                                    <Typography
                                        {...styles.locationDisplayNumberText}
                                        onMouseEnter={() => onHover(index)}
                                        onMouseLeave={() => onHover(null)}
                                        style={{
                                            backgroundColor: hoveredIndex === index ? "#fff" : "#2d5787",
                                            color: hoveredIndex === index ? "#2d5787" : "#fff",
                                            border: hoveredIndex === index ? "1px solid #2d5787" : "none",
                                            cursor: "none",
                                        }}
                                    >
                                        {getLocationNumberFromPagination(index)}
                                    </Typography>
                                </GridItem>
                                <GridItem {...styles.rightSectionTextGridItem}>
                                    <GridContainer {...styles.rightSectionGridContainer}>
                                        <GridItem {...styles.searchResultLocationGridItem}>
                                            <Link
                                                {...styles.locationNameLink}
                                                onClick={() => {
                                                    generateLocationSelectClickHandler(location, index);
                                                }}
                                                data-test-selector="findLocationModal_locationSelect"
                                            >
                                                {`${location.name.toLowerCase()} Branch `}
                                            </Link>
                                            <ADIDistanceDisplay
                                                {...styles.locationDistanceDisplayText}
                                                distance={location.distance}
                                                unitOfMeasure={distanceUnitOfMeasure}
                                            />
                                        </GridItem>
                                        <GridItem {...styles.searchResultAddressInfoGridItem}>
                                            <AddressInfoCondensedDisplay
                                                {...styles.locationAddressInfoCondensed}
                                                {...location}
                                            />
                                        </GridItem>
                                        {location.phone && (
                                            <>
                                                <GridItem {...styles.searchResultPhoneGridItem}>
                                                    <Typography>{translate("Phone: ")}&nbsp;</Typography>
                                                    <Link
                                                        href={`tel:${location.phone}`}
                                                        {...styles.searchResultPhoneLink}
                                                        target="_blank"
                                                    >
                                                        {location.phone}
                                                    </Link>
                                                </GridItem>
                                            </>
                                        )}
                                        <GridItem {...styles.searchResultGoogleMapsDirectionLinkGridItem}>
                                            <ADIGoogleMapsDirectionLink
                                                {...styles.locationGoogleMapsDirectionLink}
                                                {...location}
                                            />

                                            <Typography
                                                as="p"
                                                {...styles.showdetailsparagraph}
                                                onClick={() => showdetailssection(index)}
                                            >
                                                {uncollapsedUser === index ? (
                                                    <Typography {...styles.iconHover}>
                                                        {" "}
                                                        {translate("Hide Details")}
                                                        <StyledIcon size={18} src={ChevronUp} />
                                                    </Typography>
                                                ) : (
                                                    <Typography {...styles.iconHover}>
                                                        {" "}
                                                        {translate("Show Details")}{" "}
                                                        <StyledIcon size={18} src={ChevronDown} />
                                                    </Typography>
                                                )}
                                            </Typography>
                                        </GridItem>
                                        {uncollapsedUser === index && (
                                            <GridItem {...styles.managesecstyle}>
                                                <GridItem {...styles.searchResultManagerGridItem}>
                                                    <Typography as="p">{translate("Manager")}</Typography>
                                                    <Typography>{location?.properties?.manager}</Typography>
                                                </GridItem>
                                                {location.htmlContent && (
                                                    <>
                                                        <GridItem {...styles.searchResultContentGridItem}>
                                                            <Typography as="p" className="hoursText">
                                                                {translate("Hours")}
                                                            </Typography>
                                                            {parse(location?.htmlContent || "", parserOptions)}
                                                        </GridItem>
                                                    </>
                                                )}
                                            </GridItem>
                                        )}
                                    </GridContainer>
                                </GridItem>

                                {
                                    <GridItem {...styles.searchResultDividerGridItem}>
                                        <StyledWrapper {...styles.searchResultDivider} />
                                    </GridItem>
                                }
                            </GridContainer>
                        </GridItem>
                    ))}
                </GridContainer>
            </ContainerCell>
            <ContainerCell {...styles.paginationRow}>
                <LocationPagination
                    {...styles.pagination}
                    locations={locations}
                    locationsPagination={locationsPagination}
                    setPage={setPage}
                    setPageSize={setPageSize}
                />
            </ContainerCell>
        </Container>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSearchForm);
